import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bank",
  "use": "icon-bank-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bank\"><path d=\"M1024.064 417.024V897.024a64 64 0 0 1-64 64H64.064a64 64 0 0 1-64-64V417.024h1024z m-128 321.28h-256v96h256v-96zM960.064 65.024a64 64 0 0 1 64 64v192H0.064V129.024a64 64 0 0 1 64-64h896z\" p-id=\"1863\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol